import { Controller } from "@hotwired/stimulus"
import { debugLog } from "../utils"

export default class extends Controller {
  static targets = ["note", "form", "hiddenNote"]

  connect() {
    debugLog("ProcessTransferController: connected")
  }

  attachNote() {
    if (!this.hasNoteTarget) {
      return
    }
    const noteValue = this.noteTarget?.value?.trim() || ""
    if (this.hasHiddenNoteTarget) {
    this.hiddenNoteTarget.value = noteValue
    } 
  }
}